import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Music2, KeyRound } from "lucide-react";
import { useSite } from "../context/SiteContext";

const NAV = [
  { label: "Home", path: "/" },
  { label: "Royal Vault", path: "/vault" },
  { label: "Official Music", path: "/official-music" },
  { label: "About", path: "/about" },
  { label: "Royal List", path: "/royal-list" },
];

export const Footer = () => {
  const site = useSite();
  const SOCIALS = [
    { label: "Instagram", icon: Instagram, href: site.social_instagram || "#", testid: "social-instagram" },
    { label: "YouTube", icon: Youtube, href: site.social_youtube || "#", testid: "social-youtube" },
    { label: "Facebook", icon: Facebook, href: site.social_facebook || "#", testid: "social-facebook" },
    { label: "TikTok", icon: Music2, href: site.social_tiktok || "#", testid: "social-tiktok" },
  ];
  return (
  <footer data-testid="site-footer" className="bg-gallery border-t border-gold/15">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif text-2xl sm:text-3xl tracking-[0.15em] text-cream">QUEEN DENAE</p>
          <p className="mt-4 text-sand text-sm leading-relaxed max-w-xs">
            {site.hero_tagline || "Soul. Story. Style. No permission required."}
          </p>
          <p className="mt-6 font-mono text-[11px] tracking-[0.25em] text-gold/70 uppercase" data-testid="footer-contact-email">
            {site.contact_email || "[CONTACT EMAIL]"}
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] tracking-[0.3em] text-gold/80 uppercase mb-6">Navigate</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.path}>
                <Link to={n.path} data-testid={`footer-link-${n.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-sand hover:text-gold transition-colors duration-300">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[11px] tracking-[0.3em] text-gold/80 uppercase mb-6">Follow the Queen</p>
          <div className="flex items-center gap-4">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={s.testid}
                className="w-11 h-11 rounded-full border border-gold/25 flex items-center justify-center text-sand hover:text-obsidian hover:bg-gold hover:border-gold transition-colors duration-300"
              >
                <s.icon size={17} />
              </a>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs text-sand/70 hover:text-gold transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-xs text-sand/70 hover:text-gold transition-colors">Terms</Link>
            <Link to="/admin" data-testid="footer-owner-login-link" className="text-xs text-sand/40 hover:text-gold transition-colors inline-flex items-center gap-1.5">
              <KeyRound size={11} /> Owner Login
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-gold/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-sand/60">© {new Date().getFullYear()} Queen Denae / Stunner Media and Entertainment. All rights reserved.</p>
        <p className="font-mono text-[10px] tracking-[0.3em] text-gold/40 uppercase">QueenDenae.com</p>
      </div>
    </div>
  </footer>
  );
};
